<div class="container" *ngIf="!this.loading else loadingTemplate">
  <section class="follow-up__intro">
    <div class="follow-up__content">
      <div class="follow-up__text">
        <h1 i18n>Nuestros especialistas</h1>
        <p i18n>
          El acompañamiento personalizado que ofrecemos en Bhavani nace de una visión profunda del bienestar: un proceso
          que requiere no solo claridad técnica, sino también presencia emocional, contención y guía humana.
        </p>
        <p i18n>
          Estas sesiones individuales han sido diseñadas para quienes desean integrar su proceso con mayor profundidad,
          claridad y continuidad.
        </p>
        <p i18n>
          Cada espacio está enfocado en acompañarte de forma cercana en cada etapa de tu camino. Incluye recursos
          prácticos cuidadosamente sugeridos por el especialista, que fortalecen y enriquecen tu experiencia de manera
          coherente, consciente y transformadora.
        </p>

        <h2 i18n>¿Qué incluye este servicio?</h2>
        <ul>
          <li i18n>Acompañamiento individual con especialistas certificados en microdosis</li>
          <li i18n>Espacios para ajustar tu protocolo, resolver dudas y recibir orientación personalizada</li>
          <li i18n>Profundizar en tu experiencia emocional, física y mental</li>
          <li i18n>Recomendaciones de herramientas simples que fortalezcan la integración de tu protocolo y favorezcan
            la
            continuidad del proceso (según tus necesidades y momento personal)</li>
          <li i18n>Modalidad flexible: semanal, quincenal, mensual o según tu necesidad</li>
          <li i18n>Puedes elegir desde una sesión puntual hasta un plan con mayor continuidad</li>
        </ul>

        <hr>
        <h3 class="meet-specialists" i18n>Conoce a nuestros especialistas certificados</h3>
        <div class="Therapists" *ngIf="this.specialists.length else noTherapistsTemplate">
          <div class="Therapists__Card cursor-pointer" *ngFor="let specialist of specialists"
            [routerLink]="['/platform/follow-up/plans/.']" [queryParams]="{userId: specialist?.id}">
            <div class="header">
              <div class="rounded__pic" [ngStyle]="{'width':'100px','height':'100px', 'borderRadius': '12px'}"
                [style.background-image]="'url('+specialist.avatar+')'">
              </div>
              <div class="languages">
                <p class="d-flex align-items-center gap-2 mb-0">
                  <span *ngIf="specialist.speaks_english" class="bh-languages" i18n>Inglés</span>
                  <span class="bh-languages" *ngIf="specialist.speaks_spanish" i18n>Español</span>
                </p>
              </div>
            </div>
            <div>
              <h1 class="Therapists__Card--name">{{specialist.full_name}}</h1>
              <p class="Therapists__Card--description">{{ this.locale==='en' && specialist?.title_en ?
                specialist?.title_en
                : (specialist.title ? specialist.title : specialist.title_en)}}</p>
              <p class="Therapists__Card--short_bio"
                [innerHTML]="this.locale==='en' && specialist?.short_bio_en ? specialist?.short_bio_en : (specialist.short_bio ? specialist.short_bio : specialist.short_bio_en)">
              </p>
            </div>
            <div class="mt-auto">
              <a class="Therapists__Card--ancla text-black underlined" [routerLink]="['/platform/follow-up/plans/.']"
                [queryParams]="{userId: specialist?.id}" i18n>Ver más información</a>
            </div>
          </div>
        </div>
      </div>



      <div class="follow-up__image">
        <img src="assets/images/coachfollowup.png" alt="Coach escribiendo en libreta" />
        <div class="follow-up__notice">
          <strong i18n>AVISO IMPORTANTE</strong>
          <p i18n>Este servicio no tiene un enfoque clínico ni terapéutico. Es un acompañamiento profesional que
            complementa tu protocolo con microdosis desde una mirada integral.</p>
        </div>
      </div>
    </div>
  </section>
</div>

<ng-template #loadingTemplate>
  <loading-dots-component></loading-dots-component>
</ng-template>

<ng-template #noTherapistsTemplate>
  <div class="container-fluid text-center d-flex flex-column justify-content-center" style="min-height: 400px;">
    <img src="assets/images/espiral.svg" width="100" alt="Icono" style="margin: 1em auto;" />
    <h3 i18n>Por el momento no hay ningún terapeuta disponible.</h3>
    <p i18n>Intenta más tarde.</p>
  </div>